import inventoryAPI from '@/services/API/inventory'
import itemsAPI from '@/services/API/items'
import purchaseOrderAPI from '@/services/API/purchase-order'


const initInventoryProducts = function ({commit, dispatch}, inventoryId){
  dispatch('invalidateProductList');
  commit('SET_INVENTORY_ID', inventoryId);
  dispatch('fetchInventory', inventoryId);
}

const updateSelectedProduct = function ({commit, dispatch, state}){
  commit('SET_LOADING_SELECTED_PRODUCT', true);

  return inventoryAPI.getInventoryProductV2(state.selectedProduct.puid)
    .then(product=>{
      commit('UPDATE_SELECTED_PRODUCT', product);
      commit('SET_LOADING_SELECTED_PRODUCT', false);
      const index = _.findIndex(state.products, p => p.puid === product.puid);
      return dispatch('setSelectedProduct', { index: index >= 0 ? index : null, selectedProduct: product});
    })
}

const refreshSelectedProduct = function({commit, state}){
  // console.log(state.selectedProduct);
  return inventoryAPI.getInventoryProductV2(state.selectedProduct.puid)
    .then(product=>{
      commit('UPDATE_SELECTED_PRODUCT',product);


    })
}

function buildSearchAndFiltersParams(state){
  let params = {};
  // params.paging='no';
  params.orderBy = state.orderBy.orderName;
  params.direction = state.orderBy.direction;
  params.searchTerms = _.trim(state.searchTerms);
  params.limit = state.limit;
  params.page = state.page;
  params.active = 'true';

  if (state.filters.productPublishedInd != null) {
    params.webPublished = state.filters.productPublishedInd;
  }

  params.tags = state.filters.checkedTags?state.filters.checkedTags:undefined;
  params.available = state.filters.productWithQuantity || null;
  params.in_supply = state.filters.productInSupply || null;

  params.inventoryId = state.inventoryId;

 return params;
}

const fetchNextPage = function({commit, state, dispatch}) {
  if (state.page < state.pages) {
    commit('SET_PAGE', state.page + 1);
    dispatch('fetchSearchedProducts');
  }
}

const fetchPreviousPage = function({commit, state, dispatch}) {
  if (state.page > 1) {
    commit('SET_PAGE', state.page - 1);
    dispatch('fetchSearchedProducts');
  }
}

const fetchNextProductsPage = function({ commit , state}, query) {
  commit('SET_PAGE',state.page+1);
  let params = buildSearchAndFiltersParams(state);

  return inventoryAPI.fetchProducts(params,state.inventoryId)
    .then(products=>{

      if(products.count){
        commit('UPDATE_PRODUCTS', products.list);
        commit('SET_COUNT', products.count );
        commit('SET_PAGES', products.pages );
      }
    })
};

const fetchSearchedProducts = function({ commit , state}, query) {
  if(state.outDated){
    commit('SET_LOADING', true);

    let params = buildSearchAndFiltersParams(state);

    return inventoryAPI.fetchProductsV2(params,state.inventoryId)
      .then(products=>{
        commit('SET_PRODUCTS', products.list);
        if(products.count){
          commit('SET_COUNT', products.count );
          commit('SET_PAGES', products.pages );
          commit('SET_PAGE', products.page);
        }
        commit('SET_LOADING', false);
      })
  }
};

const setOrderBy = function ({commit,dispatch}, orderBy){
  commit('SET_ORDER_BY', orderBy);
  dispatch('invalidateProductList');
  dispatch('fetchSearchedProducts');
}
const setSortIcon = function ({commit,dispatch}, sortIcon){
  commit('SET_SORT_ICON', sortIcon);
  commit('INVALIDATE_LIST');
  dispatch('fetchSearchedProducts');
}
let searchTimeOut = null;
const setSearchTerms = function ({commit, dispatch}, searchTerms){
  commit('SET_SEARCH_TERMS', searchTerms);
  commit('SET_LOADING', true);
  clearTimeout(searchTimeOut)
  searchTimeOut = setTimeout(() => {
    dispatch('invalidateProductList');
    dispatch('fetchSearchedProducts');
  }, 500)

}
const changePage = function ({commit, dispatch}, page){
  commit('SET_PAGE', page);
  commit('INVALIDATE_LIST');
  dispatch('fetchSearchedProducts');
}


const setSelectedProduct = function({commit, state, dispatch}, {index, selectedProduct}){
  if(index!=null){
    commit('SET_SELECTED_INDEX', index);
    commit('SET_SELECTED_PRODUCT', state.products[index]);
  }else{
    commit('SET_SELECTED_PRODUCT', selectedProduct);
  }
  commit('SET_LOADING_SELECTED_PRODUCT_ITEMS', true);
  commit('SET_LOADING_SELECTED_PRODUCT_PURCHASE_ORDERS', true);

  itemsAPI.listItemsV2({puid: selectedProduct.puid })
    .then(items=>{
      commit('SET_SELECTED_PRODUCT_ITEMS', items);
      commit('SET_LOADING_SELECTED_PRODUCT_ITEMS', false);
    })

  purchaseOrderAPI.fetchPurchaseOrders({ paging:'no',puid:selectedProduct.puid })
    .then(purchaseOrders=>{
      commit('SET_SELECTED_PRODUCT_PURCHASE_ORDERS', purchaseOrders);
      commit('SET_LOADING_SELECTED_PRODUCT_PURCHASE_ORDERS', false);
    })
}

const fetchInventory = function ({commit, state}, inventoryId){
  return inventoryAPI.getInventory(inventoryId)
    .then(inventory=>{
      commit('SET_INVENTORY', inventory);
    })
}

const fetchSelectedProduct = function ({commit, state, dispatch}, puid){
  commit('SET_LOADING_SELECTED_PRODUCT', true);
  commit('SET_LOADING_SELECTED_PRODUCT_ITEMS', true);
  commit('SET_LOADING_SELECTED_PRODUCT_PURCHASE_ORDERS', true);
  return inventoryAPI.getInventoryProductV2(puid)
    .then(product=>{
      dispatch('setSelectedProduct',{ selectedProduct:product })
      commit('SET_LOADING_SELECTED_PRODUCT', false);
    })
}

const downloadInventoryReport = function({commit,state}, params){
  commit('SET_GLOBAL_INVENTORY_REPORT_LOADING',true);
  let filename = null;
  
  if (params.filename) {
    filename = params.filename;
  } else {
    filename = params.inventoryId==null?"inventaires":state.inventory.name;
  }

  inventoryAPI.downloadInventoryReport(params, filename)
    .then(()=>{
      commit('SET_GLOBAL_INVENTORY_REPORT_LOADING',false);
    })
    .catch((err) => {
      commit('SET_GLOBAL_INVENTORY_REPORT_LOADING',false);
    })
}

const invalidateProductList = function ({ commit }) {
  commit('SET_PAGE',1);
  commit('INVALIDATE_LIST');
}

const changeMode = function({commit}, mode){
  commit('SET_MODE',mode);
}

const setCheckedProductsTags = function({commit, dispatch}, tags){
  commit('SET_CHECKED_TAGS',tags);
  dispatch('invalidateProductList');
  dispatch('fetchSearchedProducts');
}

const setProductWithQuantity = function({commit, dispatch}, productWithQuantity){
  commit('SET_PRODUCT_WITH_QUANTITY',productWithQuantity);
  dispatch('invalidateProductList');
  dispatch('fetchSearchedProducts');
}

const setProductInSupply = function({commit, dispatch}, productInSupply){
  commit('SET_PRODUCT_IN_SUPPLY',productInSupply);
  dispatch('invalidateProductList');
  dispatch('fetchSearchedProducts');
}

const setProductPublishedInd = function({commit, dispatch}, publishedInd){
  let ind = null;
  if (publishedInd === '1') {
    ind = true;
  } if (publishedInd === '0') {
    ind = false;
  }
  commit('SET_PRODUCT_PUBLISHED_IND',ind);
  dispatch('invalidateProductList');
  dispatch('fetchSearchedProducts');
}


const setProductAvailabilityInd = function({commit, dispatch}, availabilityInd){
  let ind = null;
  if ( (_.find(availabilityInd, a => a === '2') != null && _.head(availabilityInd) !== '2') ||
        _.isEmpty(availabilityInd)) {
    commit('SET_PRODUCT_IN_SUPPLY',false);
    commit('SET_PRODUCT_WITH_QUANTITY',false);
  } else {
    if (_.find(availabilityInd, a => a === '0') != null) {
      commit('SET_PRODUCT_IN_SUPPLY',true);
      if (availabilityInd.length === 1) {
        commit('SET_PRODUCT_WITH_QUANTITY',false);
      }
    }

    if (_.find(availabilityInd, a => a === '1') != null) {
      commit('SET_PRODUCT_WITH_QUANTITY',true);
      if (availabilityInd.length === 1) {
        commit('SET_PRODUCT_IN_SUPPLY',false);
      }
    }
  }

  dispatch('invalidateProductList');
  dispatch('fetchSearchedProducts');
}


const setColumns = function({commit}, columns){
  commit('SET_COLUMNS', columns);
}

const initDefaultColumns = function({commit, state, dispatch}){
  let defaultColumns = _.filter(state.columnsOptions, c => c.default === true);
  if (localStorage.productListPreferences == null) {
    dispatch('setColumns', defaultColumns);
    localStorage.productListPreferences = JSON.stringify({ columns: defaultColumns });
  } else if(localStorage.productListPreferences != null && JSON.parse(localStorage.productListPreferences).columns == null){
    let preferences = JSON.parse(localStorage.productListPreferences);
    preferences.columns = defaultColumns;
    localStorage.productListPreferences = JSON.stringify(preferences);
    dispatch('setColumns', defaultColumns);
  } else {
    dispatch('setColumns', JSON.parse(localStorage.productListPreferences).columns);
  }
}

const resetFilters = function({commit, dispatch}, event){
  if(event != null) {
    event.stopPropagation();
  }
  commit('RESET_FILTERS');
  dispatch('invalidateProductList');
  dispatch('fetchSearchedProducts');
}

export default {
  initDefaultColumns,
  setColumns,
  initInventoryProducts,
  fetchSearchedProducts,
  // fetchNextProductsPage,
  fetchInventory,
  fetchSelectedProduct,
  setOrderBy,
  setSortIcon,
  setSearchTerms,
  changePage,
  setSelectedProduct,
  updateSelectedProduct,
  downloadInventoryReport,
  refreshSelectedProduct,
  invalidateProductList,
  changeMode,
  resetFilters,
  setCheckedProductsTags,
  setProductWithQuantity,
  setProductInSupply,
  fetchPreviousPage,
  fetchNextPage,
  setProductPublishedInd,
  setProductAvailabilityInd,
};
